import {
  drybulkCargoOperationsService,
  type GeneralInfoUpdateRequest,
} from "@services/drybulkCargoOperationsApi";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { runTransaction } from "@telemetry/runTransaction";
import { DRYBULK_CARGO_OPS_QUERY_KEYS, DRYBULK_CARGO_OPS_TELEMETRY } from "../constants";

/**
 * DBCO-0059 (R-31, AD-97) - Modify: Water Consumption and Max Feed Rate. The server decides every rule; on success the report is
 * refetched. No value reaches telemetry.
 */
export const useUpdateGeneralInfo = (operationId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: GeneralInfoUpdateRequest) =>
      runTransaction(
        {
          module: DRYBULK_CARGO_OPS_TELEMETRY.module,
          screen: DRYBULK_CARGO_OPS_TELEMETRY.finalLoadingReportScreen,
          action: "update_report_general_info",
          entityType: "cargo_operation",
          entityId: operationId,
        },
        (transactionId) =>
          drybulkCargoOperationsService.updateGeneralInfo(operationId, request, { transactionId }),
      ),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: DRYBULK_CARGO_OPS_QUERY_KEYS.finalLoadingReport(operationId),
      }),
  });
};
